module.exports = __webpack_public_path__ + "static/eraser-c0d235a3912df07bb0a31483a5d27612.jpg";